import { TIMEZONE } from "common/config";
import dayjs, { ConfigType } from "dayjs";

export const startOfDay = (date?: ConfigType) =>
  dayjs(date).startOf("day").toDate();

export const recordToFormData = (record: Record<string, unknown>) => {
  const formData = new FormData();

  for (const key in record) {
    const value = record[key];

    if (value === null || value === undefined) {
      continue;
    } else if (Array.isArray(value) && value[0] instanceof Blob) {
      value.forEach(item => {
        formData.append(key, item);
      });
    } else if (Array.isArray(value) && typeof value[0] === "string") {
      formData.append(key, value.join(","));
    } else if (value instanceof Date) {
      formData.append(key, value.toISOString());
    } else if (value instanceof Blob) {
      formData.append(key, value);
    } else {
      formData.append(key, String(value));
    }
  }

  return formData;
};

export const isArchived = (user: { archived?: string | null }) =>
  user.archived ? !!parseInt(user.archived) : false;

export const isExpired = (user: { endDate?: string | Date | null }) =>
  user.endDate
    ? dayjs(user.endDate) < dayjs().tz(TIMEZONE).startOf("day")
    : false;

export const filterUsers = ({
  user,
  filter,
  showInactive = true,
  excludeIds,
}: {
  user: {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email: string;
    archived?: string | number | null;
    endDate?: string | Date | null;
  };
  filter: string;
  showInactive?: boolean;
  excludeIds?: Set<string>;
}) => {
  if (!user.id) return false;
  if (excludeIds?.has(user.id)) return false;

  const filterText = filter.toLowerCase();
  const matchesFilter =
    filter === "" ||
    getUserName(user).toLowerCase().includes(filterText) ||
    getUserName({ ...user, lastFirst: false }).toLowerCase().includes(filterText) ||
    user.email.toLowerCase().includes(filterText);
  const isInactive =
    (typeof user.archived === "number" ? user.archived !== 0 : !!parseInt(user.archived ?? "0")) ||
    isExpired(user);

  if (!matchesFilter) return false;
  if (!showInactive && isInactive) return false;

  return true;
};

export const isAllowSavingWithNoRoles = ({
  isNoRoles,
  isVerified,
}: {
  isNoRoles: boolean;
  isVerified: boolean;
}) => {
  if (isVerified) return true;

  if (isNoRoles) {
    return false;
  }

  return true;
};

export const getUserName = ({
  firstName,
  lastName,
  lastFirst = true,
  initialsOnly = false,
}: {
  firstName?: string | null;
  lastName?: string | null;
  lastFirst?: boolean;
  initialsOnly?: boolean;
}) => {
  if (initialsOnly)
    return [firstName, lastName].filter(Boolean).join(" ");
  return (lastFirst ? [lastName, firstName] : [firstName, lastName]).filter(Boolean).join(" ");
};
